module.exports = __webpack_public_path__ + "static/media/settings.34f953ca.svg";